import { Component } from "react";
import classNames from "classnames";
import { callApi } from "./callApi";
import message from "../../_antd1.11.2/message";
import WeaLocaleProvider from "../wea-locale-provider";

const { formatMultiLang } = WeaLocaleProvider;
export const DESENSITIZATION = "desensitization__";
export const ENCRYPTION = "encryption__";
export const ENCRYPTION_CODE = "****";
export const ENCRYPTION_CODE_ICON = "ENCRYPTION_CODE_ICON";
export function desensitization(value = "") {
  return typeof value === "string" && value.indexOf(DESENSITIZATION) !== -1;
}

export function encryption(value = "") {
  return typeof value === "string" && value.indexOf(ENCRYPTION) !== -1;
}

export function doReplaceAll(datas, value, replaceValue) {
  if (datas) {
    datas.forEach(data => {
      value = value.replace(data, replaceValue);
    });
  }
  return value;
}
export function replaceByIndex(newData, keys, newKeyWords, index) {
  let result = "";
  const datas = newData.split(keys);
  datas.forEach((data, i) => {
    if (i === index) {
      result += data + newKeyWords;
    } else if (i < datas.length - 1) {
      result += data + keys;
    } else {
      result += data;
    }
  });
  return result;
}
export function getIndexFromShowArrays(index, showArrays) {
  let endIndex = 0;
  const showArray = showArrays.filter((v, i) => i < index && v !== "****");
  if (showArray) {
    endIndex = showArray.length;
  }
  return index - endIndex;
}
export function richfilter(
  data,
  keyWords,
  index,
  newKeyWord,
  noDesensitization,
  noIcon
) {
  let newData = data,
    newKeyWords = noDesensitization
      ? ""
      : newKeyWord
      ? newKeyWord
      : noIcon
      ? ENCRYPTION_CODE
      : ENCRYPTION_CODE + "${" + ENCRYPTION_CODE_ICON + "_" + index + "}",
    nodeNum = -1,
    charNum = -1,
    keys = newKeyWord ? keyWords : new RegExp(keyWords, "g"),
    nodes = new RegExp("<.*?>", "ig"), //匹配html元素
    chars = new RegExp("&.*?;", "ig"), //匹配转义字符
    oldNodes = newData.match(nodes), //存放html元素的数组
    oldChars = newData.match(chars); //存放转义字符的数组
  newData = newData.replace(nodes, "{~}"); //替换html标签
  newData = newData.replace(chars, "{~~}"); //替换转义字符
  if (newKeyWord) {
    newData = replaceByIndex(newData, keys, newKeyWords, index);
  } else {
    newData = newData.replace(keys, newKeyWords); //替换key
  }
  newData = newData.replace(/{~}/g, () => {
    //恢复html标签
    nodeNum++;
    return oldNodes[nodeNum];
  });
  newData = newData.replace(/{~~}/g, () => {
    //恢复html标签
    charNum++;
    return oldChars[charNum];
  });
  return newData;
}
export function matchDesensitization(value, bool) {
  const exp = bool ? /\*\*\*\*/ : DESENSITIZATION + "__random__[A-Z0-9]{32}";
  const patt = bool ? exp : new RegExp(exp, "g");
  return value.match(patt);
}
export function replaceDesensitization(value, noIcon) {
  const matches = matchDesensitization(value);
  let dataFilter = value;
  if (matches) {
    matches.forEach((keyWords, index) => {
      dataFilter = richfilter(dataFilter, keyWords, index, "", false, noIcon);
    });
  }
  return dataFilter;
}
export function replaceEncryption(value) {
  const patt = new RegExp(ENCRYPTION + "__random__[A-Z0-9]{32}", "g");
  const matches = value.match(patt);
  let dataFilter = value;
  if (matches) {
    matches.forEach((keyWords, index) => {
      dataFilter = richfilter(dataFilter, keyWords, index, ENCRYPTION_CODE);
    });
  }
  return dataFilter;
}
export class EncryBase extends Component {
  static defaultProps = {
    className: "",
    prefixCls: "wea-encry-base",
    noDesensitization: false,
    customParams: {}
  };
  constructor(props) {
    super(props);
    this.state = {
      showValue: false,
      valIndex: 0,
      clickIndex: 0,
      desValue: matchDesensitization(props.value || ""), // 存放需解密的数据
      showArrays: this.initShowArrays(props.value || ""), // 存放加密及解密数据
      realVal: "",
      encryBaseIndex: Math.random()
        .toString(36)
        .substr(2, 6),
      canClick: true,
      decryptValue: props.decryptValue || ""
    };
  }
  componentDidMount() {
    window[`encryChangeShow${this.state.encryBaseIndex}`] = this.changeShow;
    const { decryptValue } = this.props;
    this.setState({
      decryptValue,
      realVal: replaceEncryption(
        replaceDesensitization(this.transToHTML(this.props.value || ""))
      )
    });
  }
  componentWillReceiveProps(nextProps) {
    const { value: _value } = this.props;
    const { value, decryptValue } = nextProps;
    if (value !== _value) {
      this.init(value, decryptValue);
    }
  }
  componentWillUnmount() {
    window[`encryChangeShow${this.state.encryBaseIndex}`] = null;
  }
  init = (value, decryptValue) => {
    this.setState({
      decryptValue,
      realVal: replaceEncryption(
        replaceDesensitization(this.transToHTML(value || ""))
      ),
      valIndex: 0,
      clickIndex: 0,
      desValue: matchDesensitization(value || ""), // 存放需解密的数据
      showArrays: this.initShowArrays(value || ""), // 存放加密及解密数据
      canClick: true
    });
  };
  initShowArrays = value => {
    const matches = matchDesensitization(value);
    if (value && matches) {
      return new Array(matches.length).fill(ENCRYPTION_CODE);
    }
    return [];
  };
  transToHTML = (val = "") => {
    let result = val
      .replace(/gt;/g, ">")
      .replace(/&lt;/g, "<")
      .replace(/\n/g, "<br/>")
      .replace(/\r/g, "<br/>")
      .replace(/&nbsp;/g, " ")
      .replace(/&apos;/g, "'")
      .replace(/&quot;/g, '"');
    return result;
  };
  transFormHtml = value => {
    const patt = new RegExp(DESENSITIZATION + "__random__[A-Z0-9]{32}", "g");
    return value.match(patt);
  };
  getEncryptDesensitizationInfo = params => {
    const { onClick, visibleCallback, customParams = {} } = this.props;
    const { clickIndex, realVal, desValue } = this.state;
    const value = desValue[clickIndex];
    if (params && params.status === "1") {
      const param = {
        token: params.token,
        value
      };
      callApi(
        "/api/encrypt/desensitization/getEncryptDesensitizationInfo",
        "POST",
        { ...param, ...customParams }
      ).then(data => {
        if (data.status === "1") {
          this.doChangeValue(
            realVal,
            "****",
            '<span class="encry-value-' +
              clickIndex +
              '">' +
              data.value +
              "</span>"
          );
          if (typeof onClick === "function") onClick(data.value);
        } else {
          message.error(data.msg);
        }
        this.setState({ canClick: true }); // canClick 释放禁止点击标记
        if (typeof visibleCallback === "function") visibleCallback(false);
      });
    } else {
      this.setState({ canClick: true }); // canClick 释放禁止点击标记
      if (typeof visibleCallback === "function") visibleCallback(false);
    }
  };
  doChangeValue = (realVal, md, replaceVal) => {
    let { valIndex, showArrays, clickIndex } = this.state;
    showArrays[clickIndex] = replaceVal;
    const dataFilter = richfilter(realVal, md, valIndex, replaceVal);
    this.setState({ realVal: dataFilter, showArrays });
  };
  changeShow = (e, index) => {
    e && e.stopPropagation && e.stopPropagation();
    e && e.preventDefault && e.preventDefault();
    if (this.state.encryBaseIndex !== e.target.getAttribute("attrIndex"))
      return;
    const { canClick } = this.state;
    if (!canClick) return;
    this.setState({ canClick: false }, () => {
      // 禁止点击事件，防止多次点击
      const { realVal, desValue } = this.state;
      let { showArrays } = this.state;
      const { customParams = {} } = this.props;
      if (showArrays[index] === ENCRYPTION_CODE) {
        // 解密过程
        const matches = matchDesensitization(realVal, true);
        if (matches && matches.length > 0) {
          const valIndex = getIndexFromShowArrays(index, showArrays);
          this.setState({ valIndex, clickIndex: index }, () => {
            if (typeof window.doCheckSecondaryVerify4ec === "function") {
              const { visibleCallback } = this.props;
              if (typeof visibleCallback === "function") visibleCallback(true);
              window.doCheckSecondaryVerify4ec(
                { value: desValue[index], ...customParams },
                this.getEncryptDesensitizationInfo
              );
            }
          });
        }
      } else {
        // 加密过程
        const exp = showArrays[index];
        showArrays[index] = ENCRYPTION_CODE;
        const realVals = realVal.split(exp);
        let result = realVals[0] + ENCRYPTION_CODE + realVals[1];
        this.setState({ realVal: result, showArrays, canClick: true }); // canClick 释放禁止点击标记
        const { onEncry } = this.props;
        if (typeof onEncry === "function") onEncry(result);
      }
    });
  };
  // 仅render使用，用于渲染展示图标
  getShowVal = (showVal, keyWords, index, showIndexs) => {
    const { showArrays } = this.state;
    const { noDesensitization, ecId = "" } = this.props;
    const encryIcon =
      showArrays[index] && showArrays[index] === ENCRYPTION_CODE
        ? "<span class='icon-coms-hide' ecid='" +
          ecId +
          "@j6h774'" +
          "attrIndex= " +
          this.state.encryBaseIndex +
          " onclick='javascript: window.encryChangeShow" +
          this.state.encryBaseIndex +
          "(event," +
          index +
          ")'></span>"
        : "<span class='icon-coms-Supervise' ecid='" +
          ecId +
          "@j6h774'" +
          "attrIndex= " +
          this.state.encryBaseIndex +
          " onclick='javascript: window.encryChangeShow" +
          this.state.encryBaseIndex +
          "(event," +
          index +
          ")'></span>";
    showVal = richfilter(showVal, keyWords, 0, encryIcon, noDesensitization);
    const matches = showVal.match(/\${ENCRYPTION_CODE_ICON_[0-9]}/);
    index++;
    if (matches)
      showVal = this.getShowVal(showVal, matches[0], index, showIndexs);
    return showVal;
  };
  canClick = () => {
    const { showArrays } = this.state;
    const {
      controlClick = "0" // '0': 不做控制； ‘1’: 有解密数据且无需完全解密 ‘2’：需完全解密
    } = this.props;
    if (controlClick === "0") return true;
    else if (
      controlClick === "1" &&
      showArrays.find(val => val !== ENCRYPTION_CODE)
    )
      return true;
    else if (
      controlClick === "2" &&
      !showArrays.find(val => val === ENCRYPTION_CODE)
    )
      return true;
    return false;
  };
  clearDefaultval = e => {
    e && e.stopPropagation && e.stopPropagation();
    e && e.preventDefault && e.preventDefault();
    const { onClick } = this.props;
    this.setState({ decryptValue: "" }, () => {
      if (typeof onClick === "function") onClick("");
    });
  };
  filterLabel = showVal => {
    if (desensitization(showVal)) {
      const matches = matchDesensitization(showVal);
      if (matches && matches.length > 0) {
        showVal = doReplaceAll(matches, showVal, "****");
      }
    }
    if (encryption(showVal)) {
      const patt = new RegExp(ENCRYPTION + "__random__[A-Z0-9]{32}", "g");
      const matches = value.match(patt);
      if (matches && matches.length > 0) {
        showVal = doReplaceAll(matches, showVal, "****");
      }
    }
    return showVal;
  };
  getDefaultRender = () => {
    const { realVal, decryptValue } = this.state;
    let {
      value,
      fieldName,
      style,
      className,
      prefixCls,
      ...resProps
    } = this.props;
    const {
      hasBorder,
      underline,
      helpfulTip,
      helpfulTipProps,
      encryType,
      valueProps
    } = resProps;
    const showValue = this.canClick();
    let showVal = realVal;
    if (!showValue)
      showVal = showVal.replace(/javascript:/g, "javascript: function(){};"); // 禁止标签上带的方法
    const matches = showVal.match(/\${ENCRYPTION_CODE_ICON_[0-9]}/);
    const showIndexs = [];
    if (matches && matches[0]) {
      showVal = this.getShowVal(showVal, matches[0], 0, showIndexs);
    }
    // 过滤标签中的加密数据
    showVal = this.filterLabel(showVal);
    if (encryType === "INPUT") {
      const readonly = classNames({
        border: hasBorder,
        underline: underline
      });
      return (
        <div
          className={`wea-field-readonly ${prefixCls} ${readonly} ${this.props
            .className || ""}`}
          style={style}
        >
          {decryptValue ? (
            <span
              className="child-item wdb"
              {...valueProps}
              onClick={showValue && valueProps && valueProps.onClick}
            >
              <span
                dangerouslySetInnerHTML={{
                  __html: formatMultiLang(decryptValue)
                }}
              />
              <span
                class="icon-coms-Supervise"
                ecId={`${this.props.ecId}_span@a142aa`}
                onClick={this.clearDefaultval}
              />
            </span>
          ) : (
            <span
              className="child-item wdb"
              {...valueProps}
              ecId={`${this.props.ecId || ""}_span@gbwz1t`}
              onClick={showValue && valueProps && valueProps.onClick}
              dangerouslySetInnerHTML={{ __html: formatMultiLang(showVal) }}
            />
          )}

          {helpfulTip && (
            <WeaHelpfulTip
              ecId={`${this.props.ecId || ""}_WeaHelpfulTip@ggbsaw`}
              style={{ position: "absolute", right: -31, top: 4 }}
              title={helpfulTip}
              {...helpfulTipProps}
            />
          )}
        </div>
      );
    }
    return (
      <div
        className={`${prefixCls}  ${className}`}
        style={style}
        id={fieldName}
        ecId={`${this.props.ecId || ""}_WeaTools_Encry@g0kzbs`}
      >
        {decryptValue ? (
          <span
            {...valueProps}
            onClick={showValue && valueProps && valueProps.onClick}
          >
            <span
              dangerouslySetInnerHTML={{
                __html: formatMultiLang(decryptValue)
              }}
            />
            <span
              class="icon-coms-Supervise"
              ecId={`${this.props.ecId}_span@2479aA`}
              onClick={this.clearDefaultval}
            />
          </span>
        ) : (
          <span
            {...valueProps}
            ecId={`${this.props.ecId || ""}_span@e0vu9a`}
            onClick={showValue && valueProps && valueProps.onClick}
            dangerouslySetInnerHTML={{ __html: formatMultiLang(showVal) }}
          />
        )}
      </div>
    );
  };
}

export class Encry extends EncryBase {
  render() {
    return this.getDefaultRender();
  }
}

export default EncryBase;



// WEBPACK FOOTER //
// ./ecology9/wea-tools/Encry.base.js